import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Citerne, CiterneConsommationAgg } from '@/types';

interface CiterneState {
  citernes: Citerne[];
  notAffectedCiternes: Citerne[];
  consommations: CiterneConsommationAgg[];
  pageNum: number;
  totalPages: number;
}

const initialState: CiterneState = { citernes: [], notAffectedCiternes: [], consommations: [], pageNum: 0, totalPages: 0 };

const citerneSlice = createSlice({
  name: 'citerne',
  initialState,
  reducers: {
    setCiternes(state, action: PayloadAction<Citerne[] | { data: Citerne[]; pageNum?: number; totalPages?: number }>) {
      const payload = action.payload;
      if (Array.isArray(payload)) {
        state.citernes = payload;
        state.pageNum = 0;
        state.totalPages = 0;
      } else {
        state.citernes = payload.data ?? [];
        if (payload.pageNum != null) state.pageNum = payload.pageNum;
        if (payload.totalPages != null) state.totalPages = payload.totalPages;
      }
    },
    addCiterne(state, action: PayloadAction<Citerne>) {
      state.citernes.push(action.payload);
    },
    removeCiterne(state, action: PayloadAction<Citerne>) {
      state.citernes = state.citernes.filter((c) => c.id !== action.payload.id);
    },
    editCiterne(state, action: PayloadAction<Citerne>) {
      const i = state.citernes.findIndex((c) => c.id === action.payload.id);
      if (i !== -1) state.citernes[i] = action.payload;
    },
    setNotAffectedCiternes(state, action: PayloadAction<Citerne[]>) {
      state.notAffectedCiternes = action.payload;
    },
    setConsommations(state, action: PayloadAction<CiterneConsommationAgg[]>) {
      state.consommations = action.payload;
    },
  },
});

export const { setCiternes, addCiterne, removeCiterne, editCiterne, setNotAffectedCiternes, setConsommations } = citerneSlice.actions;
export default citerneSlice.reducer;
